(function () {
  function initLanding(root) {
    if (root.dataset.landingInitialized === 'true') return;
    root.dataset.landingInitialized = 'true';

    var attempts = 0;

    function unlockPage() {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.documentElement.removeAttribute('scroll-lock');

      var overlay = root.querySelector('[data-tavya-vc-overlay]');
      if (overlay) overlay.hidden = true;
    }

    function openLandingBooking() {
      attempts += 1;

      if (typeof root.tavyaVcOpenPopup === 'function') {
        root.tavyaVcOpenPopup();
        unlockPage();
        return;
      }

      if (attempts < 100) {
        window.setTimeout(openLandingBooking, 50);
      }
    }

    root.addEventListener('click', function (event) {
      var doneButton = event.target.closest('.tavya-vc-step[data-step="4"] [data-tavya-vc-close]');
      if (!doneButton) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.reload();
    }, true);

    window.addEventListener('pageshow', unlockPage);
    window.setTimeout(openLandingBooking, 0);
  }

  function initAllLandings() {
    document.querySelectorAll('[data-tavya-vc-landing-root]').forEach(initLanding);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllLandings);
  } else {
    initAllLandings();
  }

  document.addEventListener('shopify:section:load', initAllLandings);
})();
